import { AppState } from '@/store';
import { useCartSummary } from '@features/cart/hooks';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import MeterProgress from './MeterProgress';

const FreePromoMeter = ({ className = '' }) => {
  const displayCartSummary = useCartSummary();
  const { potentialPromoCode } = useSelector((state: AppState) => state.cartItemList);

  if (!potentialPromoCode) return null;

  return (
    <MeterProgress
      description={potentialPromoCode.addMoreDescription}
      className={className}
      progress={
        potentialPromoCode?.applicableDiscount?.subtotalThreshold
          ? (displayCartSummary.discountedSubtotalUnformatted /
              potentialPromoCode?.applicableDiscount?.subtotalThreshold) *
            100
          : undefined
      }
    />
  );
};

export default memo(FreePromoMeter);
